import { Video, kinoTimer, room} from "../libs/roomnew";
import stringTest from "./stringTest";
import moment from 'moment';
export default class TimerComponent{

    constructor(){
        // this.component = null;
        this.componentLabel = 'Timer';
        this.componentSubLabel = 'Set a timer countdown.';
        this.componentId='';
        this.components = []
        this.showCountDown = true;
        this.playCountDownSound = true;
        this.playTimer = true;

        //timer visibility state
        this.showTimer = false;
        this.min = 0;
        this.sec = 30;

        this.strTest = new stringTest();
    }

    events(){
        // alert(kinoTimer.showCountDown)
        
    }

    renderTimerComponent(parent, playTimer=false){
        // console.log('parent attr: ',);
        let switchId = parent.attr('id');
        this.componentId = switchId;
        let rt = this;
        rt.components.push(switchId);
        let playTimerContainer = '';
        // console.log('komponentat: ',rt.components)
        rt.errorMessageContainer = $('<div/>',{
            class: 'd-flex w-100 justify-content-center align-center mt-1 error_kino ignore-drag',
            html: ''
        })
        
        if (playTimer){
            let playTimerSpan = $('<span/>',{
                class: 'kino-slider round',
            });

            let playTimerInput = $('<input/>',{
                type: 'checkbox',
                checked: rt.playTimer
            });
    
            let playTimerSwitch = $('<label/>',{
                class: 'switch',
                html: [playTimerInput, playTimerSpan]
            }).on('change', 'input', function () {
                if (rt.playTimer) {
                    rt.playTimer = false;
                    console.log(rt.playTimer);
                } else {
                    rt.playTimer = true;
                    console.log(rt.playTimer);
                }
            });
    
            playTimerContainer = $('<div/>',{
                class: 'd-flex mt-2 w-100 align-items-center justify-content-between kino-toggle',
                html: ['Play timer', playTimerSwitch]
            });
        }
        

        let playSoundCountdownSpan = $('<span/>',{
            class: 'kino-slider round',
        });

        this.playSoundCountdownInput = $('<input/>',{
            type: 'checkbox',
            disabled: !rt.showCountDown,
            checked: rt.playCountDownSound
        }).on('change click', function(e){
            // console.log($(this).prop('checked'))
            // if($(this).prop('checked')){
            //     kinoTimer.playCountDownSound = true;
            // }else{
            //     kinoTimer.playCountDownSound = false;
            // }
        });

        let playSoundCountdownSwitch = $('<label/>',{
            class: 'switch',
            html: [this.playSoundCountdownInput, playSoundCountdownSpan]
        });

        let playSoundCountdownContainer = $('<div/>',{
            class: 'd-flex mt-2 w-100 align-items-center justify-content-between kino-toggle',
            html: ['Play notification sound', playSoundCountdownSwitch]
        });

        rt.minutesOrSecCountdown = $('<span/>',{
            class: 'mr-1',
            html: 'seconds'
        })

        rt.notificationTimeInputMinutes = $('<input/>',{
            type: 'text',
            maxlength: 2,
            value: '00',
        }).on('input paste change',function(e){
            $(this).val(e.currentTarget.value.replace(/[^0-9]/g, ''));
            let val = e.currentTarget.value
            let regTest = rt.strTest.timerTest(val);
            $(this).val(regTest);
            if(kinoTimer.durationToSeconds(rt.notificationTimeInputMinutes.val(), rt.notificationTimeInputSeconds.val()) > 59){
                rt.minutesOrSecCountdown.html('minutes')
            }else{
                rt.minutesOrSecCountdown.html('seconds')
            }
        }).on('blur', function(e){
            // console.log(e.currentTarget.value)
            if(e.currentTarget.value < 10 && e.currentTarget.value != ''){
                $(this).val('0'+ parseInt(e.currentTarget.value))
            }
            if(e.currentTarget.value == ''){
                $(this).val('00')
            }
            if(kinoTimer.durationToSeconds(rt.notificationTimeInputMinutes.val(), rt.notificationTimeInputSeconds.val()) > 59){
                rt.minutesOrSecCountdown.html('minutes')
            }else{
                rt.minutesOrSecCountdown.html('seconds')
            }
        }).on('keydown', function(e){
            let value = $(this).val();
            if(value != NaN && ((e.keyCode == '38' && value < 59) || (e.keyCode == '40' && value > 0))){
                if(e.keyCode == '38' && value < 59){
                    value++
                }
                if(e.keyCode == '40' && value > 0){
                    value--
                }

                if(value < 10){
                    value = `0${value}`;
                }else{
                    parseInt(value);
                }
                $(this).val(value);
                if(kinoTimer.durationToSeconds(rt.notificationTimeInputMinutes.val(), rt.notificationTimeInputSeconds.val()) > 59){
                    rt.minutesOrSecCountdown.html('minutes')
                }else{
                    rt.minutesOrSecCountdown.html('seconds')
                }
            }
        });

        rt.notificationTimeInputSeconds = $('<input/>',{
            type: 'text',
            maxlength: 2,
            value: 10,
        }).on('input paste change',function(e){
            $(this).val(e.currentTarget.value.replace(/[^0-9]/g, ''));
            let val = e.currentTarget.value
            let regTest = rt.strTest.timerTest(val);
            $(this).val(regTest);
            if(kinoTimer.durationToSeconds(rt.notificationTimeInputMinutes.val(), rt.notificationTimeInputSeconds.val()) > 59){
                rt.minutesOrSecCountdown.html('minutes')
            }else{
                rt.minutesOrSecCountdown.html('seconds')
            }
        }).on('blur', function(e){
            // console.log(e.currentTarget.value)
            if(e.currentTarget.value < 10 && e.currentTarget.value != ''){
                $(this).val('0'+ parseInt(e.currentTarget.value))
            }
            if(e.currentTarget.value == ''){
                $(this).val('00');
            }
            if(kinoTimer.durationToSeconds(rt.notificationTimeInputMinutes.val(), rt.notificationTimeInputSeconds.val()) > 59){
                rt.minutesOrSecCountdown.html('minutes')
            }else{
                rt.minutesOrSecCountdown.html('seconds')
            }
        }).on('keydown', function(e){
            let value = $(this).val();
            if(value != NaN && ((e.keyCode == '38' && value < 59) || (e.keyCode == '40' && value > 0))){
                if(e.keyCode == '38' && value < 59){
                    value++
                }
                if(e.keyCode == '40' && value > 0){
                    value--
                }

                if(value < 10){
                    value = `0${value}`;
                }else{
                    parseInt(value);
                }
                $(this).val(value);
                if(kinoTimer.durationToSeconds(rt.notificationTimeInputMinutes.val(), rt.notificationTimeInputSeconds.val()) > 59){
                    rt.minutesOrSecCountdown.html('minutes')
                }else{
                    rt.minutesOrSecCountdown.html('seconds')
                }
            }
        });

        rt.mSpan = $('<span/>',{
            class: 'timer-mm-ss-span',
            html:'mm'
        })
        rt.sSpan = $('<span/>',{
            class: 'timer-mm-ss-span',
            html:'ss'
        })
        rt.minuteWrapper = $('<div/>',{
            class: 'd-flex flex-column',
            html: [rt.notificationTimeInputMinutes, rt.mSpan]
        })

        rt.secondWrapper = $('<div/>',{
            class: 'd-flex flex-column',
            html: [rt.notificationTimeInputSeconds, rt.sSpan]
        })


        rt.notificationTimeInput = $('<div/>',{
            class: 'input-time',
            html: [rt.minuteWrapper,':',rt.secondWrapper]
        })

        let showTimesUpInputNotification = $('<div/>',{
            class: `w-100 notification-kino-timer-container ${rt.showCountDown ? '': 'hide'}`,
            html: ['Show a ', rt.notificationTimeInput, /*rt.minutesOrSecCountdown,*/ 'countdown notification']
        })

        let showTimesUpSpan = $('<span/>',{
            class: 'kino-slider round',
            id: `${switchId}-showTimesUpSpan`,
        })
        this.showTimesUpInput = $('<input/>',{
            type: 'checkbox',
            id: `${switchId}-showTimesUpInput`,
            checked: rt.showCountDown
        }).on('change click', function(e){
            // console.log($(this).prop('checked'))
            if($(this).prop('checked')){
                // clearTimeout(kinoTimer.animationTimeout);
                rt.playSoundCountdownInput.attr('disabled', false);
                // showTimesUpNotificationContainer.append(showTimesUpInputNotification);
                showTimesUpInputNotification.removeClass('hide');
                // kinoTimer.animationTimeout = setTimeout(()=>{
                // },50)
            }else{
                // clearTimeout(kinoTimer.animationTimeout);
                showTimesUpInputNotification.addClass('hide');
                rt.playSoundCountdownInput.attr('disabled', true).prop('checked', false);
                // kinoTimer.animationTimeout = setTimeout(()=>{
                //     showTimesUpInputNotification.remove();
                // },300)
            }
        });

        let showTimesUpLabel = $('<label/>',{
            class: 'switch',
            id: `${switchId}-showTimesUpLabel`,
            html: [this.showTimesUpInput, showTimesUpSpan]
        })

        let showTimesUpNotification = $('<div/>',{
            class: 'd-flex w-100 align-items-center justify-content-between',
            id: `${switchId}-showTimesUpNotification`,
            html: ['Show time\'s up notification', showTimesUpLabel]
        })

        let showTimesUpNotificationContainer = $('<div/>',{
            class: 'd-flex flex-column w-100 mt-2',
            id: `${switchId}-showTimesUpNotificationContainer`,
            html: [showTimesUpNotification,showTimesUpInputNotification]
        })

        this.minutesInput = $('<input/>',{
            type: 'text',
            maxlength: '2',
            id: `${switchId}-minutesInput`,
            value: rt.min < 10 ? '0'+rt.min : rt.min
        }).on('input paste change',function(e){
            $(this).val(e.currentTarget.value.replace(/[^0-9]/g, ''));
            let val = e.currentTarget.value
            let regTest = rt.strTest.timerTest(val);
            $(this).val(regTest);
            rt.min = regTest;
            if(kinoTimer.durationToSeconds(rt.min, rt.sec) > 59){
                rt.minutesOrSec.html('minutes')
            }else{
                rt.minutesOrSec.html('seconds')
            }
        }).on('blur', function(e){
            // console.log(e.currentTarget.value)
            if(e.currentTarget.value < 10 && e.currentTarget.value != ''){
                $(this).val('0'+ parseInt(e.currentTarget.value))
                rt.min = '0'+ parseInt(e.currentTarget.value);
            }
            if(e.currentTarget.value == ''){
                $(this).val('00')
                rt.min = 0;
            }
            if(kinoTimer.durationToSeconds(rt.min, rt.sec) > 59){
                rt.minutesOrSec.html('minutes')
            }else{
                rt.minutesOrSec.html('seconds')
            }
        }).on('keydown', function(e){
            let value = $(this).val();
            if(value != NaN && ((e.keyCode == '38' && value < 59) || (e.keyCode == '40' && value > 0))){
                if(e.keyCode == '38' && value < 59){
                    value++
                }
                if(e.keyCode == '40' && value > 0){
                    value--
                }

                if(value < 10){
                    value = `0${value}`;
                }else{
                    parseInt(value);
                }
                $(this).val(value);
                rt.min = value;
                if(kinoTimer.durationToSeconds(rt.min, rt.sec) > 59){
                    rt.minutesOrSec.html('minutes')
                }else{
                    rt.minutesOrSec.html('seconds')
                }
            }
        });
        this.secondsInput = $('<input/>',{
            type: 'text',
            maxlength: '2',
            id: `${switchId}-secondsInput`,
            value: rt.sec < 10 ? '0'+rt.sec : rt.sec
        }).on('input paste change',function(e){
            $(this).val(e.currentTarget.value.replace(/[^0-9]/g, ''));
            let val = e.currentTarget.value
            let regTest = rt.strTest.timerTest(val);
            $(this).val(regTest);
            rt.sec = regTest;
            if(kinoTimer.durationToSeconds(rt.min, rt.sec) > 59){
                rt.minutesOrSec.html('minutes')
            }else{
                rt.minutesOrSec.html('seconds')
            }
        }).on('blur', function(e){
            // console.log(e.currentTarget.value)
            if(e.currentTarget.value < 10 && e.currentTarget.value != ''){
                $(this).val('0'+ parseInt(e.currentTarget.value))
                rt.sec = '0'+ parseInt(e.currentTarget.value);
            }
            if(e.currentTarget.value == ''){
                $(this).val('00');
                rt.sec = 0;
            }
            if(kinoTimer.durationToSeconds(rt.min, rt.sec) > 59){
                rt.minutesOrSec.html('minutes')
            }else{
                rt.minutesOrSec.html('seconds')
            }
        }).on('keydown', function(e){
            let value = $(this).val();
            if(value != NaN && ((e.keyCode == '38' && value < 59) || (e.keyCode == '40' && value > 0))){
                if(e.keyCode == '38' && value < 59){
                    value++
                }
                if(e.keyCode == '40' && value > 0){
                    value--
                }

                if(value < 10){
                    value = `0${value}`;
                }else{
                    parseInt(value);
                }
                $(this).val(value);
                rt.sec = value;
                if(kinoTimer.durationToSeconds(rt.min, rt.sec) > 59){
                    rt.minutesOrSec.html('minutes')
                }else{
                    rt.minutesOrSec.html('seconds')
                }
            }
        });
        let timerInputs = $('<div/>',{
            class: 'input-time',
            id: `${switchId}-timerInputs`,
            html: [this.minutesInput, ':', this.secondsInput]
        })
        rt.minutesOrSec = $('<span/>',{
            html: `${
                kinoTimer.lastTimerSeconds ? kinoTimer.lastTimerSeconds < 60 ? 'seconds' : 'minutes' :
                kinoTimer.durationToSeconds(rt.min, rt.sec) < 60 ? 'seconds' : 'minutes'
            }`
        })
        let timerFieldsContainer = $('<div/>',{
            class: 'd-flex align-items-center',
            id: `${switchId}-timerFieldsContainer`,
            html: ['Set a timer for ', timerInputs , rt.minutesOrSec]
        })
        let timerContainer = $('<div/>',{
            class: 'timer-container-component flex-column w-100 ignore-drag kino-toggle',
            id: `${switchId}-timerContainer`,
            html: [timerFieldsContainer, showTimesUpNotificationContainer, playSoundCountdownContainer, playTimerContainer, rt.errorMessageContainer]
        })
        let showTimerSwitchSpan = $('<span/>',{
            id: `${switchId}-showTimerSwitchSpan`,
            class: 'kino-slider round',
        })
        this.showTimerSwitchInput = $('<input/>',{
            type: 'checkbox',
            id: `${switchId}-showTimerSwitchInput`,
        }).on('change click', function(){
            if($(this).prop('checked')){
                rt.showTimer = true;
                if(switchId=='move-options-auto'){
                    $("#split-auto-repeat-enabled").prop('checked',false).trigger('change');
                }
                timerContainer.addClass('show');
            }else{
                rt.showTimer = false;
                timerContainer.removeClass('show');
            }
        })
        let componentSwitch = $('<label/>',{
            class: 'switch',
            id: `${switchId}-componentSwitch`,
            html: [this.showTimerSwitchInput, showTimerSwitchSpan]
        })
        let label = $('<span/>',{
            html: rt.componentLabel
        });
        let subLabel = $('<span/>',{
            class: 'split-option-paragraph',
            html: rt.componentSubLabel
        })
        let labelContainer = $('<span/>',{
            class: 'split-option-container',
            html: [label,subLabel]
        });
        let componentContainer = $('<div/>',{
            class: 'd-flex justify-content-between align-items-center w-100 kino-toggle',
            id: `${switchId}-componentContainer`,
            html:[labelContainer, componentSwitch]
        });
        let component = $('<div/>',{
            class: 'd-flex flex-column w-100',
            id: `${switchId}-component`,
            html: [componentContainer, timerContainer]
        })

        parent.append(component)
    }

    setEnabled(enabled){
        if(!enabled){
            this.showTimerSwitchInput.prop({disabled:true,checked:false});
            this.showTimerSwitchInput.closest('.kino-toggle')
            .attr('data-toggle','tooltip')
            .attr('data-placement','top')
            .attr('data-original-title','This feature is disabled in this workspace.') 
        }else{
            this.showTimerSwitchInput.prop({disabled:false}); 
        }
    }

    updateTimerInputs(){
        let rt = this;
        let time = kinoTimer.secondsToTime(kinoTimer.lastTimerSeconds);
        let switchId=this.componentId;
            console.error('ELEMENT: ',switchId)
            if(time){
                rt.minutesInput.val(time.m);
                rt.secondsInput.val(time.s);
                rt.min = time.m;
                rt.sec = time.s;
            }

            // if(rt.notificationTimeInput.val()){
            //     $(`#${switchId}-notificationTimeInput`).val(kinoTimer.showNotificationCountDownAt);
            // }

            if(rt.showTimesUpInput.is(':checked')){
                rt.playSoundCountdownInput.attr('disabled', false);
            }else{
                rt.playSoundCountdownInput.attr('disabled', true).prop('checked', false)
            }

            // if(kinoTimer.playCountDownSound){
            //     $(`#${switchId}-playSoundCheckbox`).attr('disabled', false).prop('checked', true)
            // }else{
            //     $(`#${switchId}-playSoundCheckbox`).attr('disabled', !$(`#${switchId}-showTimesUpInput`).is(':checked')).prop('checked', false)
            // }
         
    }

    getSeconds(){
        return kinoTimer.durationToSeconds(this.min, this.sec)
    }
    isShown(){
        // console.trace("is shown timer ",this.showTimerSwitchInput.is(':checked'));
        return this.showTimerSwitchInput.is(':checked');
    }

    validateTimer(){
        let rt = this;
        if(!rt.isShown()){return true}
        let min = parseInt(rt.minutesInput.val());
        let sec = parseInt(rt.secondsInput.val());
        let durationSeconds = kinoTimer.durationToSeconds(min, sec);
        let notificationShowTime = kinoTimer.durationToSeconds(rt.notificationTimeInputMinutes.val(), rt.notificationTimeInputSeconds.val());
        if(durationSeconds < 10){
            rt.errorMessageContainer.html('Minimum timer duration is 10 seconds');
            return false;
        }
        if(rt.showTimesUpInput.is(':checked') && durationSeconds < notificationShowTime){
            rt.errorMessageContainer.html('Time\'s up notification cannot be set higher than the timer');
            return false;
        }

        return true;
    };

    async sendStartTimerCommand(){
        let rt = this;
        if(!rt.isShown()){return}
        let min = parseInt(rt.minutesInput.val());
        let sec = parseInt(rt.secondsInput.val());
        let durationSeconds = kinoTimer.durationToSeconds(min, sec);
        let seconds = durationSeconds ? durationSeconds : kinoTimer.lastTimerSeconds; 
        let showNotification = rt.showTimesUpInput.is(':checked');
        let notificationShowTime = kinoTimer.durationToSeconds(rt.notificationTimeInputMinutes.val(), rt.notificationTimeInputSeconds.val());
        // if(isNaN(notificationShowTime) || notificationShowTime <= 5){
        //     notificationShowTime=10;
        // }
        let playNotificationSound=rt.playSoundCountdownInput.is(':checked');
        if(durationSeconds < 60){
            rt.minutesOrSec.html('seconds')
        }else{
            rt.minutesOrSec.html('minutes')
        }
        // let startImmediately = true;
        // let fromComponent = true;
        // kinoTimer.startNewTimer(duration, startImmediately, fromComponent);
        rt.errorMessageContainer.html('')
        let timeNow=moment();
        let timerID=new Date().getTime();
        kinoTimer.stopTimer(true);
        kinoTimer.activeTimersID = timerID;
        kinoTimer.myTimer=seconds;
        let server=await kinoTimer.getServerTime(seconds,1);
        let options={
            hostStartDate:timeNow,
            seconds:seconds,
            id: kinoTimer.activeTimersID,
            from_id:room.myUserId(),
            from_name: MY_NAME,
            seconds_left: null,
            showCountDown: showNotification,
            startCountDownAt : notificationShowTime,
            playCountDownSound: playNotificationSound,
            serverStartTime: server.start,
            serverEndTime: server.end,
            playTimer: rt.playTimer
        };

        kinoTimer.sendTimerMessage(options);
        kinoTimer.startTimer(options,"You"); 
        
        console.error("started kino timer from comopnent",options);
        return true;
    }

}